<mat-form-field class="w-100" [tcTooltip]="tooltipText" [placement]="tooltipPlacement">
    <mat-label>{{ name }}</mat-label>

    <input
        matInput
        type="text"
        [pattern]="_pattern"
        [(ngModel)]="value"
        (ngModelChange)="_onChangeCallback($event)"
        (blur)="_onTouchedCallback()"
        autocomplete="off"
        [disabled]="isDisabled"
        [required]="isRequired"
        #control="ngModel"
    />

    <input
        matInput
        type="color"
        [(ngModel)]="value"
        autocomplete="off"
        (ngModelChange)="_onChangeCallback($event)"
        (blur)="_onTouchedCallback()"
        [disabled]="isDisabled"
        [required]="isRequired"
    />
    <mat-error *ngIf="control.hasError('required')">
        {{ 'validators.required' | translate: _locale.language }}
    </mat-error>

    <mat-error *ngIf="control.hasError('pattern')">
        {{ 'validators.patternHex' | translate: _locale.language }}
    </mat-error>
</mat-form-field>
